// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4TZdA","title":"Info_title__21Gwc","links":"Info_links__36GHE","link":"Info_link__2CkJC","logo":"Info_logo__2SkGt"};